import * as FaIcons from "react-icons/fa";

export const viewIconMap = {
  FaThLarge: FaIcons.FaThLarge,
  FaMedkit: FaIcons.FaMedkit,
  FaUsers: FaIcons.FaUsers,
  FaMoneyCheck: FaIcons.FaMoneyCheck,
  FaHandHoldingUsd: FaIcons.FaHandHoldingUsd,
  FaCalculator: FaIcons.FaCalculator,
  FaFolderOpen: FaIcons.FaFolderOpen,
  FaScroll: FaIcons.FaScroll,
  FaFileInvoice: FaIcons.FaFileInvoice,
  FaBoxes: FaIcons.FaBoxes,
  FaLock: FaIcons.FaLock,
  FaBook: FaIcons.FaBook,
  FaStethoscope: FaIcons.FaStethoscope
};

export const getViewIcon = (iconName) => viewIconMap[iconName] || FaIcons.FaThLarge;

export const ViewIcon = ({ name, className = "" }) => {
  const IconCmp = getViewIcon(name);
  return <IconCmp className={className} />;
};
